/**
 * useNoIndex — adds noindex meta tag for internal/operator apps.
 * Prevents search engines from indexing non-public apps.
 */
import { useEffect } from 'react';

export function useNoIndex(): void {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"][data-noindex]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      meta.setAttribute('data-noindex', 'true');
      document.head.appendChild(meta);
    }
    meta.content = 'noindex,nofollow';

    return () => {
      meta?.remove();
    };
  }, []);
}
